// <auto-generated />
// ATENCAO: Arquivo auto-gerado pelo SetupController. Nao altere manualmente.

export const CATFIN_TP_MOV = {
  Custo: 'CATFIN_TP_MOV1',
  Despesa: 'CATFIN_TP_MOV2',
  Receita: 'CATFIN_TP_MOV3',
  Imposto: 'CATFIN_TP_MOV4',
  NA: 'CATFIN_TP_MOV5',
  // Mapa de sequencia (SequenciaLista) para lookup por codigo
  sequencia: {
    CATFIN_TP_MOV1: 1,
    CATFIN_TP_MOV2: 2,
    CATFIN_TP_MOV3: 3,
    CATFIN_TP_MOV4: 4,
    CATFIN_TP_MOV5: 5
  }
}
